import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import TopSideBar from '../../components/TopSideBar'
import TitlebarAction from '../../components/common/TitlebarActions'
import { PADDING_BASE } from '../../assets/Styles'
import PageContainer from '../../components/common/PageContainer'
import ElementEntities from '../../components/EntitiesSettings/ElementEntities'
import { useProject } from '../../context/ProjectContext'

interface ElementEntitiesPage {
  setBlockScreen: (p: boolean) => void
}

const ElementEntitiesPage: React.FC<ElementEntitiesPage> = ({ setBlockScreen }) => {
  const { isProjectUndefined } = useProject();

  return <>
    <TopSideBar currentSection='element-entities' />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="400">
            Administración
          </Typography>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="600">
            Entidades de Elemento
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction title='Entidades de Elemento' />

      {!isProjectUndefined() && (
        <ElementEntities setBlockScreen={setBlockScreen} />
      )}

    </PageContainer>
  </>
}

export default ElementEntitiesPage;